import "./initEnv";
import React from 'react';
import ReactDOM from 'react-dom/client';
//import './assets/css/App.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';
import { WhiteLabelProvider } from './contexts/WhiteLabelContext';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ChakraProvider theme={theme}>
    <AuthProvider>
      <BrowserRouter>
        <WhiteLabelProvider>
          <App />
        </WhiteLabelProvider>
      </BrowserRouter>
    </AuthProvider>
  </ChakraProvider>,
);